var path = 'chatter/chatter.tpl.html';
var html = "<div class=\"chatter\">\n    <div class=\"row\" ui-view=\"backup\" autoscroll=\"false\"></div>\n    <div class=\"row\" ui-view=\"progress\" autoscroll=\"false\"></div>\n    <div class=\"chatter-border\"></div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;